import React from 'react';
import { Typography as MuiTypography } from '@material-ui/core';

export const Typography = (props) => {
    return (<MuiTypography {...props} />);
}